import { TStatus, TPaymentMode } from '../finance/finance.interfaces';

export type TFeeComponentTemplate = {
  id: string;
  instituteRef: string;
  name: string;
  description: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  totalFee: number;
  feeComponents: TFeeComponentBase[];
};

export type TFeeComponentBase = {
  componentId: string;
  componentName: string; // E.g., "Hostel", "Library", "Lab"
  description: string; // Description of the component
  amount: number; // Amount of the component
};

/** Per-category selection when parent opts in/out during admission */
export interface ISelectedFeeComponent {
  componentId: string;
  optedIn: boolean; // false = opted out (only valid if component is optional)
}

export interface IAdmissionFeeSelection {
  gradeId: string;
  categoryId: string;
  selectedComponents: ISelectedFeeComponent[];
}

export type TFeeComponent = TFeeComponentBase & {
  id: string;
  dueDate: string | null; // Due date for this component, if applicable
  status: TStatus; // Status of this component's payment
  paidAmount: number; // Amount paid so far for this component
  createdBy: string;
  instituteRef: string;
  purpose: string;
  academicYear: number;
  /** true if optional component and parent opted out */
  isOptedOut?: boolean;
};

export type TPaymentHistory = {
  paymentDate: Date; // Date of payment
  paymentMode: TPaymentMode; // Mode of payment
  amountPaid: number; // Amount paid in this transaction
  referenceId?: string; // Optional reference ID for the payment
};

export type TStudentFees = {
  studentId: string; // Unique identifier for the student
  academicYear: string; // Year for which the fees are tracked (e.g., "2023-2024")
  totalFee: number; // Total fee calculated by summing up all components
  feeComponents: TFeeComponent[]; // Array of fee components with details
  totalPaid: number; // Total amount paid till now
  outstandingBalance: number; // Amount yet to be paid
  paymentHistory: TPaymentHistory[]; // Array of payments made so far
  status: TStatus; // Overall status of the fees
};

export type TStudentFeeSummary = {
  feeId: string;
  userId: string;
  feeAmount: number;
  feePaid: number;
  feeDue: number;
  feeDueDate: string;
  feePaidDate: string;
  status: TStudentFeeViewType;
};

export enum TStudentFeeViewType {
  ALL = 'all',
  UNPAID = 'unpaid',
  PAID = 'paid',
  DUE = 'due',
  OVERDUE = 'overdue',
}
